// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7189abd2","455":"7796d776","977":"a13d8733"}[chunkId] + ".chunk.js";
};